
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Pageable } from "app/models/pageable-mode";
import { BehaviorSubject } from "rxjs";

export abstract class AbPortaria extends AppService {

  abstract pageablePessoaUnidade: Pageable;
  abstract filterPessoaUnidade: AppFilter;
  abstract previsaoVisitaId: BehaviorSubject<boolean>;
  abstract getPrevisaoVisita();
  abstract getAllPrevisaoVisitas(filter: AppFilter);
  abstract getRelatorioPrevisaoVisita(filter: AppFilter);
  abstract getAllPrevisoesPortaria(filter: AppFilter);
  abstract getAllPrevisoesPortariaAgenda(filter: AppFilter);
  abstract desativarPrevisaoVisita(id: number);
  abstract getPessoaUnidade();
  abstract getVisitantesUnidadeByNome(filter: AppFilter);
  abstract registrarEntrada(portaria: any);
  abstract getAllVisitantes(filter: AppFilter);
  abstract findVisitanteByCurrentPessoaUnidadeAndDocumentoWhenNotInUnidade(documento, unidadeId);
  abstract registrarSaida(entity);
  abstract getVisitanteById(id);
  abstract getPrevisaoVisitaById(id);
  abstract getPrevisaoVisitaQRCode(id, deviceId, fingerPrint);
  abstract getVisitantePreCadastroConviteById(id, deviceId, fingerPrint);
  abstract findVisitanteByDocumento(documento);
  abstract saveVisitante(visitante);
  abstract getPrevisaoVisitaAbrirPortaQRCode(json);
  abstract getPrevisaoVisitaAbrirPortaKey(json);
  abstract getVisitanteListaConvidados(id);
  abstract getVisitantePreCadastro(id);
  abstract salvarConvidado(id, convidado);
  abstract findByPortariaVisitanteId(id: number);
  abstract getVisitanteByPortariaId(id);
  abstract salvarPrevisaoVisita(entity);
}
